import styled from "styled-components";

import { ProfileNavigationStyledProps as Props } from "./ProfileNavigation.types";
import CONSTANTS from "config/constants";

const { BREAKPOINTS } = CONSTANTS;
const { tablet } = BREAKPOINTS;

const ProfileNavigationStyled = styled.div<Props>`
  display: flex;
  flex-direction: column;
  height: max-content;
  border-radius: 0.8rem;
  background-color: var(--palette-black-s2-l17);

  .ProfileNavigation {
    &__preview {
      border-radius: 0.8rem;
      background-color: var(--palette-black-s2-l17);
    }

    &__tab {
      display: flex;
      align-items: center;
      padding: 1.6rem;
      text-decoration: none;
      border-top: 0.1rem solid var(--palette-black-s0-l10);

      @media (max-width: ${tablet}px) {
        padding: 1.6rem 1.2rem;
      }

      &.is-currently-active {
        background: var(--palette-gray-s0-l10);
        /* border-left: 0.2rem solid var(--palette-primary); */

        path {
          fill: var(--palette-white);
        }
      }
    }

    &__tab-icon {
      path {
        fill: var(--palette-white);
      }
    }

    &__tab-name {
      padding-left: 2.4rem;
      font-size: 1.6rem;
      font-weight: 600;
      color: var(--palette-white);

      &--active {
        color: var(--palette-white);
      }
    }

    &__logout-button {
      display: flex;
      padding-left: 0.8rem;
      font-family: inherit;
      font-size: 1.6rem;
      font-weight: 600;
      border: none;
      background: transparent;
      cursor: pointer;
      padding: 1.6rem;
      color: var(--palette-white);
      border-top: 0.1rem solid var(--palette-black-s0-l10);

      @media (max-width: ${tablet}px) {
        padding: 1.6rem 0;
        padding-left: 1.2rem;
      }
    }
  }
`;

export default ProfileNavigationStyled;
